module.exports = {
  // 测试服务器
  api: {
    host: '112.29.139.153',
    port: 8081,
    protocol: 'http'
  }
}
